<template>

  <div>
    <el-form :model="formData" label-width="200px" :rules="rules">
      <el-form-item label="设备类型：" prop="star" style="width: 500px">
        <el-select v-model="formData.type_id" placeholder="设备类型">
          <el-option v-for="dict in deviceTypeAll" :key="dict.value" :label="dict.label"
                     :value="dict.value"></el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="巡检设备：">
          <spna>共</spna>
          <spna style="color: #0486fe"> {{ formData.device_num }}</spna>
          <span>个设备</span>
        </el-form-item>
      <el-row class="box">
        <el-icon @click="addOneConfig()" color="#0486fe" size="25" style="cursor: pointer;position:absolute;margin-top: 3px;margin-left: -40px"><ElIconCirclePlusFilled /></el-icon>
        <el-col :span="3">序号</el-col>
        <el-col :span="4">周期</el-col>
        <el-col :span="15">点检项目描述</el-col>
      </el-row>
      <el-row v-for="(item,index) in formData.configList" :key="index" class="row" :gutter="10"
              style="margin-left: 100px;width: 600px;margin-top: 10px">

        <el-col :span="3" style="text-align: center;">
          <spna>{{ index + 1 }}</spna>
        </el-col>
        <el-col :span="4">
          <el-select v-model="item.cycle" placeholder="周期" clearable>
            <el-option v-for="dict in cycleList" :key="dict.value" :label="dict.name"
                       :value="dict.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="17">
          <el-input v-model="item.describe" placeholder="点检项目描述"></el-input>
        </el-col>

        <div class="close" @click="removeOneConfig(item.nanoid)">
          <el-icon color="red" size="25"><ElIconRemove/></el-icon>
        </div>
      </el-row>

      <el-form-item>
        <el-button style="margin-top: 20px" type="success" @click="addSpotCheckConfig" :loading="loading">提交</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import {nanoid} from 'nanoid'

export default {
  name: "EqSpotCheckConfigZhiZaoAdd",
  inject:['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      formData: {
        patrol_table_name: '',
        device_num: 1,
        configList: [],
      },
      deviceListAll: [],
      deviceTypeAll: [],

      rules: {
        star: [{required: true, message: '', trigger: 'blur'}],
      },
    }
  },
  computed: {
    cycleList() {
      return this.$store.getters['core/getDictList']("cycle_type");
    },
  },
  methods: {
    addFiveConfig() {
      for (let i = 0; i < 1; i++) {
        this.formData.configList.push({
          nanoid: nanoid(),
        })
      }
    },

    addOneConfig() {
      this.formData.configList.push({
        nanoid: nanoid(),
      })
      this.formData.device_num = this.formData.configList.length
    },

    removeOneConfig(nanoid) {
      let index = this.formData.configList.findIndex(item => item.nanoid === nanoid);
      this.formData.configList.splice(index, 1);
      this.formData.device_num = this.formData.configList.length
    },

    async getDeviceTypeAll() {
      await this.$http('eqDsZhiZaoService.getEqDeviceTypeAll',{}, false).then(data => {
        this.deviceTypeAll = data
      }, errMsg => {
        return this.$message.error(errMsg);
      })
    },

    addSpotCheckConfig() {
      this.loading = true
      if (!this.formData.type_id) {
        this.loading = false
        return this.$message.error('设备类型不能为空!')
      }
      let cnt = 0;
      for (let i = 0; i < this.formData.configList.length; i++) {
        let obj = this.formData.configList[i]
        if (!obj.cycle){
          this.loading = false
          return this.$message.error(`第${i + 1}行周期不能为空`);
        }
        if (!obj.describe){
          this.loading = false
          return this.$message.error(`第${i + 1}行描述不能为空`);
        }
        cnt++
      }
      if (cnt == 0) {
        this.loading = false
        return this.$message.error("点检项目数据不能为空");
      }
      this.$http('eqSpotCheckConfigZhiZaoService.addSpotCheckConfig',this.formData).then(data => {
        this.loading = false
        this.$fn.closeWindow();
        this.$fn.search();
        return this.$message.success('添加成功!');
      }, errMsg => {
        this.loading = false
        return this.$message.error(errMsg);
      })
    }

  }, created() {
    this.addOneConfig()
    this.getDeviceTypeAll()

  }
}
</script>

<style scoped>
.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
  width: 600px;
  color:black;
  margin-left: 100px

}

.close {
  position: absolute;
  top: 5px;
  margin-left: -40px;
  font-size: 18px;
  cursor: pointer;
}
</style>